import { useEffect, useState } from "react";
import ButtonComponent from "../../../components/common/button/Button"
import Modal from "../../../components/common/modal/Modal";
import { ReAssignPlanner, ReAssingPlannerFooter } from "../WorkflowManagement/ReassignToPlannersModal";
import './reassignModal.css';
import { useMsal } from "@azure/msal-react";
import axios from "axios";

export const ReAssignModal = ({ rowCount, disableSendForApprovalButton, reAssignSubmitAPI, textAreaValueForSend, setBulkPDTDisabled, setBulkPDTValue }) => {

    const [openReassign, setOpenReassign] = useState(false);
    const [selectedName, setSelectedName] = useState("");
    const [selectedEmailId, setSelectedEmailId] = useState("");
    const [reAssignComments, setReAssignComments] = useState(textAreaValueForSend);
    const [allUsers, setAllUsers] = useState([]);
    const { instance, accounts } = useMsal();
    useEffect(() => {
        setReAssignComments(textAreaValueForSend)
        getAllUser()
    }, [openReassign])

    const getAllUser = async () => {
        const account = instance?.getAllAccounts()[0];
        instance?.setActiveAccount(account);
        const tokenRequest = {
            scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
        };
        const response = await instance?.acquireTokenSilent(tokenRequest);
        const accessToken = response?.accessToken;
        const url=`${process.env.REACT_APP_BACKEND_BASE_URL}/api/lt/planners`
        axios.get(url,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    withCredentials: true
                },
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode"),
                    userEmail: localStorage.getItem("data"),
                    ltRole: localStorage.getItem("LTRole"),
                    cdRole: localStorage.getItem("CDRole"),
                    ltRegion: localStorage.getItem("LTRegion")
                }
            }
        )
            .then(response => {
                const loggedInUserEmail = localStorage.getItem("data");
                const filteredUsers = response?.data.filter(user => user.email !== loggedInUserEmail);
              
                setAllUsers(filteredUsers)
            })
            .catch(error => {
                console.error('Error fetching the data:', error);
            });
    }

    const onClickReassignButton = () => {
        setOpenReassign(true);
    };

    const closeReassignModal = () => {
        clearAllDetails();
        setOpenReassign(false)
    };

    const clearAllDetails = () => {
        setSelectedName("");
        setSelectedEmailId("");
        setReAssignComments("");
    }
    const onSubmitReassign = () => {
        reAssignSubmitAPI(selectedName, selectedEmailId, reAssignComments)
        setOpenReassign(false);
        setBulkPDTDisabled(true);
        setBulkPDTValue("");
    }

    const data = [
        { id: 1, name: 'John Doe', email: 'john.doe@example.com' },
        { id: 2, name: 'Jane Smith', email: 'jane.smith@example.com' },
        { id: 3, name: 'Alice Johnson', email: 'alice.johnson@example.com' }
    ];

    const handleApproverChange = (event, value) => {
        setSelectedName(value?.name || "");
        setSelectedEmailId(value?.email || "");
    };

    const onChangeReassingComments = (event) => {
        setReAssignComments(event.target.value)
    }

    return (
        <>
            <ButtonComponent
                maxWidth="230px"
                label="Reassign to other planners"
                bgColor="black"
                color="white"
                onClick={onClickReassignButton}
                disabled={disableSendForApprovalButton}
            />
            <Modal
                className="reassignModal_cls"
                open={openReassign}
                handleClose={closeReassignModal}
                title="Reassign line items"
                action={
                    <ReAssingPlannerFooter
                        onSubmitHandler={onSubmitReassign}
                        disableSubmitButton={selectedName?.length === 0 || selectedEmailId?.length === 0 || reAssignComments?.length === 0}
                        submitLabel={"Reassign"}
                        clearAllDetails={clearAllDetails}
                    />
                }
                content={
                    <ReAssignPlanner
                        className="reassignContent_cls"
                        checkBoxCount={rowCount}
                        data={allUsers}
                        handleApproverChange={handleApproverChange}
                        selectedName={selectedName}
                        selectedEmailId={selectedEmailId}
                        reAssignComments={reAssignComments}
                        onChangeReassingComments={onChangeReassingComments}
                    />
                }
                maxWidth="100px"
            />
        </>
    )
}